import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Default Pagination"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("nav", { "aria-label": "Page navigation example" }, [
                _createElementVNode("ul", { class: "pagination" }, [
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "Previous")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "1")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "2")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "3")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "Next")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, "\n<nav aria-label=\"Page navigation example\">\n<ul class=\"pagination\">\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">Previous</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">1</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">2</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">3</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">Next</a></li>\n</ul>\n</nav>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Pagination with icons"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent2"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("nav", { "aria-label": "Page navigation example" }, [
                _createElementVNode("ul", { class: "pagination" }, [
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#",
                      "aria-label": "Previous"
                    }, [
                      _createElementVNode("span", { "aria-hidden": "true" }, "«")
                    ])
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "1")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "2")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "3")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#",
                      "aria-label": "Next"
                    }, [
                      _createElementVNode("span", { "aria-hidden": "true" }, "»")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, "\n<nav aria-label=\"Page navigation example\">\n<ul class=\"pagination\">\n<li class=\"page-item\">\n<a class=\"page-link\" href=\"#\" aria-label=\"Previous\">\n<span aria-hidden=\"true\">&laquo;</span>\n</a>\n</li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">1</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">2</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">3</a></li>\n<li class=\"page-item\">\n<a class=\"page-link\" href=\"#\" aria-label=\"Next\">\n<span aria-hidden=\"true\">&raquo;</span>\n</a>\n</li>\n</ul>\n</nav>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Pagination Disabled and active"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab3",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview3-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code3-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent3"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("nav", { "aria-label": "..." }, [
                _createElementVNode("ul", { class: "pagination" }, [
                  _createElementVNode("li", { class: "page-item disabled" }, [
                    _createElementVNode("a", { class: "page-link" }, "Previous")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "1")
                  ]),
                  _createElementVNode("li", {
                    class: "page-item active",
                    "aria-current": "page"
                  }, [
                    _createElementVNode("a", {
                      class: "page-link active",
                      href: "#"
                    }, "2")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "3")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "Next")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode3"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode3"
                }, "\n<nav aria-label=\"...\">\n<ul class=\"pagination\">\n<li class=\"page-item disabled\">\n<a class=\"page-link\">Previous</a>\n</li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">1</a></li>\n<li class=\"page-item active\" aria-current=\"page\">\n<a class=\"page-link\" href=\"#\">2</a>\n</li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">3</a></li>\n<li class=\"page-item\">\n<a class=\"page-link\" href=\"#\">Next</a>\n</li>\n</ul>\n</nav>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Pagination Size"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab4",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview4-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code4-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent4"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("nav", { "aria-label": "..." }, [
                _createElementVNode("ul", { class: "pagination pagination-lg" }, [
                  _createElementVNode("li", {
                    class: "page-item active",
                    "aria-current": "page"
                  }, [
                    _createElementVNode("span", { class: "page-link active" }, "1")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "2")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "3")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode4"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode4"
                }, "\n<nav aria-label=\"...\">\n<ul class=\"pagination pagination-lg\">\n<li class=\"page-item active\" aria-current=\"page\">\n<span class=\"page-link active\">1</span>\n</li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">2</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">3</a></li>\n</ul>\n</nav>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Pagination Size"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab5",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview5-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code5-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent5"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("nav", { "aria-label": "..." }, [
                _createElementVNode("ul", { class: "pagination pagination-sm" }, [
                  _createElementVNode("li", {
                    class: "page-item active",
                    "aria-current": "page"
                  }, [
                    _createElementVNode("span", { class: "page-link active" }, "1")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "2")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "3")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode5"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode5"
                }, "\n<nav aria-label=\"...\">\n<ul class=\"pagination pagination-sm\">\n<li class=\"page-item active\" aria-current=\"page\">\n<span class=\"page-link active\">1</span>\n</li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">2</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">3</a></li>\n</ul>\n</nav>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Pagination Center"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab55",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview55-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview55-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview55-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code55-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code55-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code55-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent55"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview55-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview55-tab",
              tabindex: "0"
            }, [
              _createElementVNode("nav", { "aria-label": "Page navigation example" }, [
                _createElementVNode("ul", { class: "pagination justify-content-center" }, [
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "Previous")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "1")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "2")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "3")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "Next")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code55-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code55-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode55"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode55"
                }, "\n<nav aria-label=\"Page navigation example\">\n<ul class=\"pagination justify-content-center\">\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">Previous</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">1</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">2</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">3</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">Next</a></li>\n</ul>\n</nav>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Pagination Right Align"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab6",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview6-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview6-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview6-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code6-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code6-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code6-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent6"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview6-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview6-tab",
              tabindex: "0"
            }, [
              _createElementVNode("nav", { "aria-label": "Page navigation example" }, [
                _createElementVNode("ul", { class: "pagination justify-content-end" }, [
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "Previous")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "1")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "2")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "3")
                  ]),
                  _createElementVNode("li", { class: "page-item" }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#"
                    }, "Next")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code6-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code6-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode6"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode6"
                }, "\n<nav aria-label=\"Page navigation example\">\n<ul class=\"pagination justify-content-end\">\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">Previous</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">1</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">2</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">3</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">Next</a></li>\n</ul>\n</nav>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Pagination Custom"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab7",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview7-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview7-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview7-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code7-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code7-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code7-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent7"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview7-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview7-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap" }, [
                _createElementVNode("span", { class: "fs-14" }, "Showing 5 of 30 Results"),
                _createElementVNode("nav", { "aria-label": "Page navigation example" }, [
                  _createElementVNode("ul", { class: "pagination mb-0 justify-content-center" }, [
                    _createElementVNode("li", { class: "page-item" }, [
                      _createElementVNode("a", {
                        class: "page-link icon",
                        href: "#",
                        "aria-label": "Previous"
                      }, [
                        _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left")
                      ])
                    ]),
                    _createElementVNode("li", { class: "page-item" }, [
                      _createElementVNode("a", {
                        class: "page-link active",
                        href: "#"
                      }, "1")
                    ]),
                    _createElementVNode("li", { class: "page-item" }, [
                      _createElementVNode("a", {
                        class: "page-link",
                        href: "#"
                      }, "2")
                    ]),
                    _createElementVNode("li", { class: "page-item" }, [
                      _createElementVNode("a", {
                        class: "page-link",
                        href: "#"
                      }, "3")
                    ]),
                    _createElementVNode("li", { class: "page-item" }, [
                      _createElementVNode("a", {
                        class: "page-link",
                        href: "#"
                      }, "4")
                    ]),
                    _createElementVNode("li", { class: "page-item" }, [
                      _createElementVNode("a", {
                        class: "page-link icon",
                        href: "#",
                        "aria-label": "Next"
                      }, [
                        _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right")
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code7-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code7-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode7"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode7"
                }, "\n<div class=\"d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap\">\n<span class=\"fs-14 fw-medium\">Showing 5 of 30 Results</span>\n\n<nav aria-label=\"Page navigation example\">\n<ul class=\"pagination mb-0 justify-content-center\">\n<li class=\"page-item\">\n<a class=\"page-link icon\" href=\"#\" aria-label=\"Previous\">\n<i class=\"material-symbols-outlined\">keyboard_arrow_left</i>\n</a>\n</li>\n<li class=\"page-item\"><a class=\"page-link active\" href=\"#\">1</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">2</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">3</a></li>\n<li class=\"page-item\"><a class=\"page-link\" href=\"#\">4</a></li>\n<li class=\"page-item\">\n<a class=\"page-link icon\" href=\"#\" aria-label=\"Next\">\n<i class=\"material-symbols-outlined\">keyboard_arrow_right</i>\n</a>\n</li>\n</ul>\n</nav>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}